export const extractStake = (amount) => {
  if (amount) {
    const totalStakedStr = amount
    const totalStakedFull = totalStakedStr.split(' ')[0]
    return parseInt(totalStakedFull)
  }
}
